import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = { class: "h-flex h-flex-space-between h-flex-dir-column" }
const _hoisted_3 = { class: "h-flex h-flex-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "h-text-center h-mb-20" }
const _hoisted_6 = { class: "b-base-title h-mt-10" }
const _hoisted_7 = {
  key: 0,
  class: "h-mt-10 h-mb-20 h-text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "h-mt-10 h-mb-20 h-text-center"
}
const _hoisted_9 = { class: "h-fw-500" }
const _hoisted_10 = { class: "h-flex-center h-flex-dir-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "420px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style--no-shadow",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#fff",
      popupRadius: "20px"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              style: {"width":"100px"},
              src: _ctx.requireImage("log-out.svg")
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('AUTH.LOG_OUT.TITLE')), 1),
            (_ctx.globalStore.userData.active)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('AUTH.LOG_OUT.ASIDE')), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOG_OUT.NOT.ACTIVE')) + " ", 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.globalStore.userData.email), 1)
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FwButton, {
            class: "h-mb-20 qa-do-logout-button",
            borderRadiusType: "medium-border",
            onClick: _ctx.logOut
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOG_OUT.YES')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", {
            class: "b-base-alert-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
          }, _toDisplayString(_ctx.$t('AUTH.LOG_OUT.NO')), 1)
        ])
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}